import React from "react";
import classNames from "classnames";
import { CategorySelectSimple } from "../../transactions/CategorySelect/CategorySelectSimple";
import { TransactionDirectionType } from "../../../common/categories";
import { Category } from "../../../common/types/category";
import { EditableTableCell, EditableTableCellProps } from "./EditableTableCell";
import styles from "./EditableTable.module.scss";

interface EditableTableCellSearchProps
    extends Omit<EditableTableCellProps, "children"> {
    onChange: undefined | ((value: string | number | null) => void);
    value: Category | undefined;
}

export const EditableTableCellCategory = React.memo(
    ({
        id,
        isFirstRow,
        onChange,
        value,
        error,
        selectionState,
    }: EditableTableCellSearchProps) => (
        <EditableTableCell
            id={id}
            isFirstRow={isFirstRow}
            error={error}
            selectionState={selectionState}
            className={classNames(
                styles.dropdownEditableCell,
                styles.categoryEditableCell,
                value && "selected-category",
            )}
        >
            <CategorySelectSimple
                showPersonal={true}
                onSelected={(category) => {
                    if (category) {
                        onChange?.(category.id);
                    }
                }}
                size="sm"
                transactionDirection={TransactionDirectionType.mixed}
                value={value}
                dropdownKey={`action-detail-category-${id}`}
            />
        </EditableTableCell>
    ),
);
